'use client';

import { cn } from '@/app/_helper/tailwind';

const NotLoggedInInfo = ({
    className,
    text,
    buttonText,
}: {
    text: string;
    className?: string;
    buttonText?: string;
}) => {
    return (
        <div
            className={cn(
                'w-full bg-lightBlue p-4 flex flex-col gap-y-4 items-center rounded-lg',
                className,
            )}
        >
            <p className='text-sm text-accent text-center'>{text}</p>
            <button
                className='bg-primary py-2 px-4 text-white font-bold rounded-lg w-max cursor-pointer'
                onClick={() => {
                    window.location.href = `/user/login?redirect=${window.location.href}`;
                }}
            >
                {buttonText || 'Login'}
            </button>
        </div>
    );
};

export default NotLoggedInInfo;
